import Provider from "./../../Provider";

import FetchSettings from "../../../interfaces/FetchSettings";
import {
  CategoryJsonPage,
  DiscussionJsonPage,
} from "../../../interfaces/JsonPage";
import {
  VanillaApiTag,
  VanillaDiscussion,
  VanillaCategory,
} from "./../../../interfaces/VanillaApi";

export default class VanillaProvider extends Provider {
  protected baseUrl = process.env.VANILLA_API_URL;

  async getCategoryFromJsonPage(catUrl = ""): Promise<CategoryJsonPage> {
    try {
      const settings: FetchSettings = {
        method: "GET",
      };
      const categoryUrl =
        catUrl === ""
          ? [location.protocol, "//", location.host, location.pathname].join("")
          : catUrl;
      const jsonCat: CategoryJsonPage = await this.request(
        categoryUrl + ".json",
        settings
      );

      return jsonCat;
    } catch (e) {
      console.error(e);
      return null;
    }
  }

  public async getCategory(
    categoryId: number
  ): Promise<VanillaCategory | null> {
    const url = new URL(this.baseUrl + "categories/" + categoryId);
    const settings: FetchSettings = {
      method: "GET",
    };
    const data: VanillaCategory = await this.request(url.toString(), settings);
    return data;
  }

  public async getCategories(
    queryOptions?: Array<string>
  ): Promise<Array<VanillaCategory>> {
    const url = new URL(this.baseUrl + "categories");
    const settings: FetchSettings = {
      method: "GET",
    };
    let requestUrl = url.toString();

    if (queryOptions) {
      requestUrl = requestUrl + "?" + queryOptions.join("&");
    }

    const data: Array<VanillaCategory> = await this.request(
      requestUrl,
      settings
    );
    return data;
  }

  async getDiscussionFromJsonPage(): Promise<DiscussionJsonPage> {
    try {
      const settings: FetchSettings = {
        method: "GET",
      };
      const jsonCat: DiscussionJsonPage = await this.request(
        [location.protocol, "//", location.host, location.pathname].join("") +
          ".json",
        settings
      );

      return jsonCat;
    } catch (e) {
      console.error(e);
      return null;
    }
  }

  public async getDiscussion(
    discussionId: number
  ): Promise<VanillaDiscussion | null> {
    const url = new URL(this.baseUrl + "discussions/" + discussionId);
    const settings: FetchSettings = {
      method: "GET",
    };
    const data: VanillaDiscussion = await this.request(
      url.toString(),
      settings
    );
    return data;
  }

  public async getTags(
    filter: Array<string> = []
  ): Promise<Array<VanillaApiTag>> {
    const settings: FetchSettings = {
      method: "GET",
    };
    const tags: Array<VanillaApiTag> = await this.request(
      this.baseUrl + "tags?" + filter.join("&"),
      settings
    );
    return tags;
  }
}
